import React from "react";
import {
  SafeAreaView,
  ScrollView,
  StyleSheet,
  Text,
  TouchableOpacity,
  View,
} from "react-native";
import { EtiquetteViewProps } from "../etiquette.types";
import EtiquetteRules from "../../../components/EtiquetteRules";

const CONTENT_MAX_WIDTH = 375;
const CARD_MAX_WIDTH = 343;

export default function EtiquetteViewMobile({
  onContinue,
  onBack,
}: EtiquetteViewProps) {
  return (
    <SafeAreaView style={styles.root}>
      <ScrollView
        contentContainerStyle={styles.scrollContent}
        showsVerticalScrollIndicator={false}
      >
        <View style={styles.content}>
          <View style={styles.navContainer}>
            <Text style={styles.title}>
              You&#39;re about to enter a safe conversation space
            </Text>
            <Text style={styles.subtitle}>
              Take a moment to review how we care for one another here.
            </Text>
          </View>

          <View style={styles.rulesContainer}>
            <EtiquetteRules variant="mobile" />
          </View>

          <View style={styles.actionButtons}>
            <TouchableOpacity
              style={styles.cancelButton}
              onPress={onBack}
              activeOpacity={0.85}
            >
              <Text style={styles.cancelButtonText}>CANCEL</Text>
            </TouchableOpacity>
            <TouchableOpacity
              style={styles.agreeButton}
              onPress={onContinue}
              activeOpacity={0.85}
            >
              <Text style={styles.agreeButtonText}>AGREE AND JOIN</Text>
            </TouchableOpacity>
          </View>
        </View>
      </ScrollView>
    </SafeAreaView>
  );
}

const styles = StyleSheet.create({
  root: {
    flex: 1,
    backgroundColor: "#232335",
  },
  scrollContent: {
    alignItems: "center",
    paddingBottom: 24,
  },
  content: {
    width: "100%",
    maxWidth: CONTENT_MAX_WIDTH,
    alignItems: "center",
    paddingHorizontal: 16,
    paddingTop: 24,
    paddingBottom: 24,
  },
  navContainer: {
    width: "100%",
    alignItems: "center",
    paddingTop: 8,
    paddingBottom: 32,
    paddingHorizontal: 8,
  },
  title: {
    fontSize: 26,
    lineHeight: 28,
    fontWeight: "700",
    color: "#f6f7f9",
    textAlign: "center",
  },
  subtitle: {
    marginTop: 8,
    fontSize: 16,
    lineHeight: 20,
    color: "#85858b",
    textAlign: "center",
  },
  rulesContainer: {
    width: "100%",
    alignItems: "center",
    paddingBottom: 24,
  },
  actionButtons: {
    width: "100%",
    maxWidth: CARD_MAX_WIDTH,
    flexDirection: "row",
    gap: 24,
    marginTop: 16,
  },
  cancelButton: {
    flex: 1,
    height: 62,
    borderRadius: 16,
    borderWidth: 1,
    borderColor: "#52526d",
    alignItems: "center",
    justifyContent: "center",
  },
  cancelButtonText: {
    fontSize: 14,
    fontWeight: "700",
    color: "#f6f7f9",
    textTransform: "uppercase",
  },
  agreeButton: {
    flex: 1,
    height: 62,
    borderRadius: 16,
    backgroundColor: "#3a6fb1",
    alignItems: "center",
    justifyContent: "center",
  },
  agreeButtonText: {
    fontSize: 14,
    fontWeight: "700",
    color: "#fff",
    textTransform: "uppercase",
  },
});
